<template>
  <v-container class="container col-lg-10 col-sm-12">
    <h1 class="pb-3 mt-4">{{ title }}</h1>
    <v-text-field
      aria-label="Search role template"
      placeholder="Type to find role template"
      v-model="searchText"
      class="text-field__no-label"
      autofocus
    />
    <div>
      <div v-if="isLoadingTemplates">
        <v-skeleton-loader
          v-for="i in 5"
          :key="i"
          type="list-item-avatar-three-line"
        />
      </div>
      <div v-else v-for="template in filteredTemplates" :key="template.id">
        <JobItem
          class="job-template"
          :loading="selectedTemplate === template"
          @click.native="stepForward(template)"
          :template="template"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import JobItem from "@/views/bookings/NewBooking/steps/components/JobItem";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { createNamespacedHelpers } from "vuex";
import { FETCH_BOOKING_TEMPLATES } from "@/store/modules/data/actions";
import {
  GET_BOOKING_TEMPLATES,
  GET_IS_FETCHING_DATA
} from "@/store/modules/data/getters";

const { mapActions, mapGetters } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  name: "RoleStep",
  components: { JobItem },
  props: {
    title: String
  },
  data() {
    return {
      searchText: "",
      isLoading: false,
      selectedTemplate: null,
      searchKeys: ["jobTitle"]
    };
  },
  computed: {
    ...mapGetters({
      bookingTemplates: GET_BOOKING_TEMPLATES,
      isFetchingData: GET_IS_FETCHING_DATA
    }),
    filteredTemplates() {
      return this.$search(this.searchText, this.bookingTemplates, {
        keys: this.searchKeys
      });
    },
    isLoadingTemplates() {
      return this.isFetchingData;
    }
  },
  created() {
    this.fetchBookingTemplates();
  },
  methods: {
    ...mapActions({
      fetchBookingTemplates: FETCH_BOOKING_TEMPLATES
    }),
    stepForward(template) {
      this.selectedTemplate = template;
      this.$emit("nextStep", { template });
    }
  }
};
</script>

<style lang="scss" scoped>
.job-template {
  cursor: pointer;
}
</style>
